import { render, staticRenderFns } from "./ManutIndicacaoPcd.vue?vue&type=template&id=6587940b&"
import script from "./ManutIndicacaoPcd.vue?vue&type=script&lang=js&"
export * from "./ManutIndicacaoPcd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports